import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = 'site_favicon_url';

const DynamicFavicon = () => {
  const [faviconUrl, setFaviconUrl] = useState(null);

  useEffect(() => {
    // Fetch settings immediately
    const fetchFavicon = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/site-settings`);
        const data = await res.json();
        let url = data.favicon || data.logo_header;
        
        if (url) {
          // Add BACKEND_URL if it's a relative path
          if (url.startsWith('/')) {
            url = `${BACKEND_URL}${url}`;
          }
          
          // Cache for instant load next time
          try {
            localStorage.setItem(CACHE_KEY, url);
          } catch (e) {
            console.debug('Could not cache favicon URL');
          }
          
          setFaviconUrl(url);
        }

        // Update page title if available
        if (data.logo_alt) {
          document.title = data.logo_alt;
        }
      } catch (err) {
        console.debug('Could not fetch site settings for favicon');
        // Try to use cached URL
        try {
          const cached = localStorage.getItem(CACHE_KEY);
          if (cached) setFaviconUrl(cached);
        } catch (e) {}
      }
    };

    fetchFavicon();
  }, []);

  useEffect(() => {
    if (!faviconUrl) return;

    // Add cache-busting parameter for fresh load
    const urlWithCache = `${faviconUrl}${faviconUrl.includes('?') ? '&' : '?'}v=${Date.now()}`;

    // Remove all existing favicons first (clean slate)
    const existingIcons = document.querySelectorAll('link[rel*="icon"]');
    existingIcons.forEach(icon => {
      // Don't remove if it's our dynamic one being updated
      if (icon.id && icon.id.startsWith('dynamic-')) {
        icon.href = urlWithCache;
      }
    });

    // Create new favicon link (primary)
    let favicon = document.getElementById('dynamic-favicon');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.id = 'dynamic-favicon';
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = urlWithCache;

    // Create shortcut icon (for Safari/IE)
    let shortcutIcon = document.querySelector('link[rel="shortcut icon"]');
    if (!shortcutIcon) {
      shortcutIcon = document.createElement('link');
      shortcutIcon.rel = 'shortcut icon';
      document.head.appendChild(shortcutIcon);
    }
    shortcutIcon.href = urlWithCache;

    // Apple touch icon
    let appleIcon = document.getElementById('dynamic-apple-icon');
    if (!appleIcon) {
      appleIcon = document.createElement('link');
      appleIcon.id = 'dynamic-apple-icon';
      appleIcon.rel = 'apple-touch-icon';
      appleIcon.sizes = '180x180';
      document.head.appendChild(appleIcon);
    }
    appleIcon.href = urlWithCache;

    // For Safari - force refresh by modifying document title briefly
    const originalTitle = document.title;
    document.title = originalTitle + ' ';
    setTimeout(() => {
      document.title = originalTitle;
    }, 10);

    console.debug('Favicon updated to:', urlWithCache);

  }, [faviconUrl]);

  return null;
};

export default DynamicFavicon;
